/**
 * Pure helpers for D2 create draft recovery (R1-2).
 * Keeps same-scope create IDs recoverable after detail refetch failure
 * without inventing client-side identities.
 */

import { sameActorId, sameCompanyId } from "../../companyWorkspace/lib/scopeSession";
import { membershipGenerationOf } from "./authorityBoundTransport";

export function buildDraftBinding({
  propertyId,
  companyId,
  actorId,
  membershipGeneration,
}) {
  if (propertyId == null || companyId == null || actorId == null) return null;
  return {
    id: propertyId,
    companyId,
    actorId,
    membershipGeneration:
      membershipGeneration === undefined ? null : membershipGeneration,
  };
}

export function draftBindingMatches(binding, live) {
  if (!binding || !live) return false;
  return (
    sameCompanyId(binding.companyId, live.companyId) &&
    sameActorId(binding.actorId, live.actorId) &&
    String(binding.membershipGeneration) ===
      String(
        live.membershipGeneration === undefined
          ? null
          : live.membershipGeneration,
      )
  );
}

/**
 * Recover a draft property id only when the stored binding still matches the
 * live actor/company/membershipGeneration authority. A bare livePropertyId
 * must never revive an invalidated binding into a new scope.
 */
export function resolveRecoverableDraftId(
  binding,
  livePropertyId,
  liveAuthority,
) {
  if (!draftBindingMatches(binding, liveAuthority)) {
    return null;
  }
  if (
    livePropertyId != null &&
    String(livePropertyId) !== String(binding.id)
  ) {
    return null;
  }
  return binding.id;
}

export function membershipGenerationFromMembership(membership) {
  return membershipGenerationOf(membership);
}
